import React from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import handoffClock from '../../../assets/onboarding/handoff-clock.svg';
import { CENTERED_BAND_MAX_HEIGHT } from '../handoffConstants';

const { Title, Text } = Typography;

/**
 * Screen 3 — terminal positive state. Reached on polling timeout, FAILED, or any
 * unrecoverable error. Framed as success, not error: the backend emails a
 * "resume" link once the operation reaches PROCESSED, so the user comes back
 * through that. No technical detail shown.
 */
const EmailScreen = () => {
	const { t } = useTranslation();

	return (
		<div
			style={{
				flex: 1,
				maxHeight: CENTERED_BAND_MAX_HEIGHT,
				minHeight: 'min-content',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				textAlign: 'center',
				padding: 24,
				gap: 48
			}}>
			<img
				src={handoffClock}
				alt=""
				style={{ width: 'min(480px, 100%)', height: 'auto', objectFit: 'contain' }}
			/>

			<div style={{ display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 640 }}>
				<Title level={3} style={{ color: '#2F4858', margin: 0, fontWeight: 700 }}>
					{t('handoff.emailTitle', '¡Ya casi está! Estamos procesando tu solicitud')}
				</Title>
				<Text style={{ color: '#748EA0' }}>
					<span
						dangerouslySetInnerHTML={{
							__html: t(
								'handoff.emailDescription',
								'Hemos recibido tus datos correctamente. <strong>Te enviaremos un correo en breve</strong> para que puedas continuar. Puedes cerrar esta pantalla sin problema.'
							)
						}}
					/>
				</Text>
			</div>
		</div>
	);
};

export default EmailScreen;
